import React from "react";
import { Stack, Typography } from "@mui/material";

const AdminNotFoundPage = () => {
  return (
    <Stack spacing={2}>
      <Typography variant='h4'>Admin Page Not Found</Typography>
      <Typography color='text.secondary'>
        The requested admin path does not exist.
      </Typography>
    </Stack>
  );
};

export default AdminNotFoundPage;
